import React, { useEffect } from 'react';
import { PhoneIcon, CalendarCheckIcon } from 'lucide-react';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { BookingProvider } from './contexts/BookingContext';
import { IntroSplash } from './components/IntroSplash';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Barbers } from './components/Barbers';
import { Gallery } from './components/Gallery';
import { HowItWorks } from './components/HowItWorks';
import { Booking } from './components/Booking';
import { LocationContact } from './components/LocationContact';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { business } from './data/business';
function Site() {
  const {
    lang,
    t
  } = useLanguage();
  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = t.meta.title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', t.meta.description);
  }, [lang, t]);
  return <div className="min-h-full w-full bg-ink font-sans" data-id="element-0" data-mp="56m9egl55mh">
      <IntroSplash data-id="element-1" data-mp="2zlv84y2h77wn" />
      <Header data-id="element-2" data-mp="2zmenc70qri6z" />
      <main data-id="element-3" data-mp="2zmwit1fkxsdu">
        <Hero data-id="element-4" data-mp="2zn66ujh2dpgw" />
        <About data-id="element-5" data-mp="33movnqc0akp0" />
        <Services data-id="element-6" data-mp="33m5a7zn5de68" />
        <Barbers data-id="element-7" data-mp="33nq4rp9gox43" />
        <Gallery data-id="element-8" data-mp="33n6y54p9hv5d" />
        <HowItWorks data-id="element-9" data-mp="33orjq4tlm3r3" />
        <Booking data-id="element-10" data-mp="38lrpsfqg76i7" />
        <LocationContact data-id="element-11" data-mp="38l8hlqqlnwhd" />
        <Testimonials data-id="element-12" data-mp="38l05i12awv78" />
        <FinalCTA data-id="element-13" data-mp="38nuorp9kw9z2" />
      </main>
      <Footer data-id="element-14" data-mp="3dkl4ucldv5kh" />

      <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-px border-t border-gold/25 bg-gold/25 sm:hidden" data-id="element-15" data-mp="3dl4n5uey3vz1">
        <a href={business.phoneHref} className="flex items-center justify-center gap-2 bg-gold py-4 font-display text-sm font-semibold uppercase tracking-wider text-ink" data-id="element-16" data-mp="nur8c681cizz">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-17" data-mp="356wji4cy4fe" />
          {t.mobileBar.call}
        </a>
        <a href="#agendar" className="flex items-center justify-center gap-2 bg-ink py-4 font-display text-sm font-semibold uppercase tracking-wider text-gold" data-id="element-18" data-mp="3uc9l01st9wlx">
          <CalendarCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-19" data-mp="86w76wno4g2y" />
          {t.mobileBar.book}
        </a>
      </div>
      <div className="h-14 sm:hidden" aria-hidden="true" data-id="element-20" data-mp="3glny8208l2ir" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-21" data-mp="3bk720jsp648i">
      <BookingProvider data-id="element-22" data-mp="3qaxrvmaqat8z">
        <Site data-id="element-23" data-mp="3qbfur1rwc5pv" />
      </BookingProvider>
    </LanguageProvider>;
}